import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-dotted-arrow-up",
  "use": "icon-s-dotted-arrow-up-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-dotted-arrow-up\"><path d=\"M11.597 12.675h-2v-8.03l-6.274 6.274L2 9.596l7.274-7.274L10.597 1l8.596 8.596-1.323 1.323-6.273-6.274zm-.97-9-.03-.03-.03.03zm.97 11v2h-2v-2zm0 4v2h-2v-2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol